import * as React from "react";
import { memo } from "react";
const Logout = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={27} height={24} {...props}>
    <path
      d="M13.333 19.064v-14l4.391 4.355 1.886-1.87L12 0 4.391 7.548l1.886 1.87 4.391-4.355v14zM24 24.355v-11.9h-2.667v11.9H2.667v-11.9H0v11.9A2.656 2.656 0 0 0 2.667 27h18.666A2.656 2.656 0 0 0 24 24.355z"
      data-name="24 / basic / share-arrow"
      style={{
        fill: "#d6b87c",
        fillRule: "evenodd",
      }}
      transform="rotate(90 13.5 13.5)"
    />
  </svg>
);
const LogoutIcon = memo(Logout);
export default LogoutIcon;
